const map = new WeakMap();
const _ = key => map.get(key) || map.set(key, {}).get(key);

class QueryEvent {
	constructor(dispatcher, ...args) {
		let defaultCallback = () => {};

		_(this).onStarted = defaultCallback;
		_(this).onHead = defaultCallback;
		_(this).onTail = defaultCallback;
		_(this).onError = defaultCallback;
		_(this).onStatusChange = defaultCallback;
		_(this).onRows = defaultCallback;

		dispatcher.apply(this, args);
		return this;
	}

	onStarted(fn) {
		_(this).onStarted = fn;
		return this;
	}
	onHead(fn) {
		_(this).onHead = fn;
		return this;
	}
	onTail(fn) {
		_(this).onTail = fn;
		return this;
	}
	onError(fn) {
		_(this).onError = fn;
		return this;
	}
	onStatusChange(fn) {
		_(this).onStatusChange = fn;
		return this;
	}
	onRows(fn) {
		_(this).onRows = fn;
		return this;
	}

	done(eventName, ...args) {
		if(!(_(this)[eventName])){
			return;
		}
		_(this)[eventName].apply(this, args);
		if(eventName === 'onTail' || eventName === 'onError') {
			map.delete(this);
		}
	}

	debug() {
		console.log(_(this));
	}

}

export default QueryEvent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/QueryEvent.js